module.exports = __webpack_public_path__ + "static/license.508cb9f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/apps/rcr/license.png
// module id = 761
// module chunks = 168707334958949